module.exports = __webpack_public_path__ + "media/images/indicators/temperatura-4129bf1a18558b94eb665b19d9731da1.png";